import { useLocation } from "react-router-dom";
import { LiveActivityFeed, ActivityFeedContext } from "./LiveActivityFeed";

export const ContextualActivityFeed = () => {
  const location = useLocation();
  
  const getContextFromRoute = (): ActivityFeedContext => {
    const path = location.pathname;
    
    // Trainers context
    if (path.includes('/trainers') || 
        path.includes('/entrenadores') || 
        path.includes('/become-trainer') ||
        path.includes('/trainer/')) {
      return 'trainers';
    }
    
    // Gyms/Listings context
    if (path.includes('/directory') || 
        path.includes('/directorio') || 
        path.includes('/listing/') ||
        path.includes('/premium-upgrade')) {
      return 'gyms';
    }
    
    // Events context
    if (path.includes('/events') || 
        path.includes('/eventos') || 
        path.includes('/event/') ||
        path.includes('/create-event')) {
      return 'events';
    }
    
    // Tribus context
    if (path.includes('/tribus') || 
        path.includes('/tribu/')) {
      return 'tribus';
    }
    
    // Professionals context (nutritionists, physiotherapists)
    if (path.includes('/servicios-profesionales') ||
        path.includes('/nutritionist') ||
        path.includes('/nutricionista') ||
        path.includes('/physiotherapist') ||
        path.includes('/fisioterapeuta')) {
      return 'professionals';
    }
    
    // Default to general
    return 'general';
  };
  
  return <LiveActivityFeed context={getContextFromRoute()} />;
};
